import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Renders the brand logo. Priority order:
 *   1. An uploaded logo (Settings → Branding & Theme), served from the backend.
 *   2. A static /public/logo.svg or logo.png dropped in manually.
 *   3. The text "WTSN Hub" wordmark.
 * See frontend/public/BRANDING.md for how to install a static logo file.
 */
function Logo({ variant = 'full', className = '' }) {
  const theme = useTheme();
  const uploadedLogoUrl = theme?.logoUrl;
  const [stage, setStage] = useState('svg'); // 'svg' -> 'png' -> 'text'
  const [uploadedFailed, setUploadedFailed] = useState(false);

  if (uploadedLogoUrl && !uploadedFailed) {
    return (
      <img
        className={`wtsn-logo wtsn-logo-img ${className}`}
        src={uploadedLogoUrl}
        alt="Logo"
        onError={() => setUploadedFailed(true)}
      />
    );
  }

  if (stage === 'text') {
    return (
      <span className={`wtsn-logo wtsn-logo-text ${className}`}>
        <span className="wtsn-logo-mark">WTSN</span>
        {variant === 'full' && <span className="wtsn-logo-tagline">Hub</span>}
      </span>
    );
  }

  return (
    <img
      className={`wtsn-logo wtsn-logo-img ${className}`}
      src={stage === 'svg' ? '/logo.svg' : '/logo.png'}
      alt="WTSN"
      onError={() => setStage(prev => (prev === 'svg' ? 'png' : 'text'))}
    />
  );
}

export default Logo;
